module.exports = __webpack_public_path__ + "static/images/monet/cog_white.svg";